import {
  ArrowDropDown,
  CheckBox,
  CheckBoxOutlineBlank,
  Sort,
} from "@mui/icons-material";
import { Button, Divider, Menu, MenuItem } from "@mui/material";
import { Fragment, useCallback, useState } from "react";
import { usePersistantStore } from "@/stores/global";

export default function DispoCalendarSettings({ listview }) {
  const settings = usePersistantStore((state) => state.getSettings());
  const setSettings = usePersistantStore((state) => state.setSettings);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);


  const open = !!anchorEl;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  console.log("asd",settings.sortDispoBy)

  return (
    <Fragment>
      <Button onClick={handleClick} endIcon={<ArrowDropDown />}>
        Ansicht
      </Button>
      <Menu open={open} anchorEl={anchorEl} onClose={close}>
        {settings.dispoExpanded ? (
          <MenuItem
            onClick={() => {
              listview.current?.hideAll();
            }}
          >
            Alles zuklappen
          </MenuItem>
        ) : (
          <MenuItem
            onClick={() => {
              listview.current?.showAll();
            }}
          >
            Alles aufklappen
          </MenuItem>
        )}
        <Divider />
        {[
          { key: "showDispoInformation", name: "Informationen" },
          { key: "showDispoMaterial", name: "Material & Logistik" },
          { key: "showDispoOrders", name: "Offene Anfragen" },
          { key: "showDispoResources", name: "Geräte & Mitarbeiter" },
        ].map((x) => (
          <MenuItem
            onClick={() => {
              setSettings({ ...settings, [x.key]: !settings[x.key] });
              close();
            }}
            key={x.key}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              {!!settings[x.key] ? <CheckBox /> : <CheckBoxOutlineBlank />}
              <div>{x.name}</div>
            </div>
          </MenuItem>
        ))}
        <Divider />
        <MenuItem
          onClick={() => {
            setSettings({
              ...settings,
              showDispoBauhof: !settings.showDispoBauhof,
            });
            close();
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            {!!settings.showDispoBauhof ? (
              <CheckBox />
            ) : (
              <CheckBoxOutlineBlank />
            )}
            <div>Zeige Bauhofbestellungen</div>
          </div>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            setSettings({
              ...settings,
              sortDispoBy: { NAME: "NUMBER", NUMBER: "STATUS", STATUS: "NAME" }[
                settings.sortDispoBy
              ],
            });
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Sort />
            <div>
              {
                { NAME: "Projektname", NUMBER: "Kostenstelle", STATUS: "Status" }[
                  settings.sortDispoBy
                ]
              }
            </div>
          </div>
        </MenuItem>
      </Menu>
    </Fragment>
  );
}
